import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Typography, Select } from 'antd';
import podsLogo from '@assets/PODS_Logo.png';
import makeApiRequest from '@apiCalls/makeApiRequest';
import { API_ENDPOINTS } from '@constants/apiEndpoints';
import { useNotification } from '@providers/NotificationProviders';
import type apiRequestConfig from '@interfaces/apiEndpoints.interface';
import * as styles from '@styles/membershipVerification.module.scss';
import CheckCircleThin from '@assets/check-circle-thin.png';

const { Option } = Select;

const { Title } = Typography;

const MemberShipVerification: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [verified, setVerified] = useState(false);
  const openNotification = useNotification();
  const token = localStorage.getItem('costcoVerificationToken');
  const onFinish = (values: any) => {
    setLoading(true);
    const response = makeApiRequest(
      {
        partnerId: 'Costco',
        customerDetails: [
          {
            customerId: values.customerId,
            membershipId: values.membershipId,
          },
        ],
        countryCode: values.countryCode,
      },
      API_ENDPOINTS.VERIFY_MEMBER as apiRequestConfig,
      '',
      {
        Authorization: `Bearer ${token}`,
        'X-Source': 'CALL_CENTER',
      }
    );
    response
      .then((res) => {
        setLoading(false);
        const memberStatus = res?.data?.members?.[0]?.verificationStatus?.statusCode;
        const memberStatusDesc =
          res?.data?.members?.[0]?.verificationStatus?.statusDescription;

        if (memberStatus === "SUCCESS") {
          setVerified(true);
          openNotification(memberStatusDesc, 'Success');
        }
        else{
          setVerified(false);
          openNotification(memberStatusDesc, 'Error');
        }
      })
      .catch((err) => {
        setLoading(false);
        openNotification('Not a valid membership id', 'Error');
      });
  };

  const handleVerifyNew = () => {
    setVerified(false);
    form.resetFields();
  };

  return (
    <section className={styles.loginBody}>
      <section className={styles.logoWeb}>
        <img src={podsLogo} alt="PODS Logo" />
      </section>
      <section className={styles.formLogin}>
        {verified ? (
          <div className={styles.successDiv}>
            <img src={CheckCircleThin} alt="Check Circle" />
            <Title className={styles.titleForm} level={1}>
              Member verified successfully
            </Title>
            <Button
              className={styles.verifyNew}
              type="primary"
              onClick={handleVerifyNew}
            >
              Verify New
            </Button>
          </div>
        ) : (
          <Form
            form={form}
            name="basic"
            layout="vertical"
            initialValues={{ remember: true, countryCode: "USA" }}
            className={styles.loginForm}
            onFinish={onFinish}
          >
            <Title className={styles.verificationTitle}>
              Member Verification
            </Title>
            <section className={styles.inputs}>
              <Form.Item
                label="PODS Customer Id"
                name="customerId"
                rules={[
                  { required: true, message: 'Please Enter PODS Customer Id' },
                ]}
                className={styles.loginInput}
              >
                <Input placeholder="Enter PODS Customer Id" />
              </Form.Item>
              <Form.Item
                label="Costco Membership Id"
                name="membershipId"
                rules={[
                  { required: true, message: 'Please Enter Membership Id' },
                ]}
                className={styles.loginInput}
              >
                <Input placeholder="Enter Membership Id" />
              </Form.Item>
              <Form.Item
                label="Select Country code"
                name="countryCode"
                rules={[{ required: true, message: 'Please select country' }]}
                className={styles.loginInput}
              >
                <Select placeholder="Select country code">
                  <Option value="CAN">CAN</Option>
                  <Option value="USA">USA</Option>
                </Select>
              </Form.Item>
              <Form.Item>
                <Button
                  className={styles.formBtn}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  Verify
                </Button>
              </Form.Item>
            </section>
          </Form>
        )}
      </section>
    </section>
  );
};

export default MemberShipVerification;
